// extracted by mini-css-extract-plugin
export default {"menuItem":"kuuuM3P5Y6iJEsPwbDZz"};